import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { swalError } from "../../utils/swalAlert.js";


export default function PaymentFailed() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const reason = searchParams.get("reason");

    let message = "پرداخت انجام نشد.";

    if (reason === "canceled") {
      message = "پرداخت توسط شما لغو شد.";
    }

    swalError({
      title: "پرداخت ناموفق",
      text: message,
    }).then(() => {
      navigate("/panel/user/my-sites", { replace: true });
    });
  }, [navigate, searchParams]);

  return null;
}